import type { CurrentUserResponse } from '@/tygo/dto'
import { apiFetch } from '@/lib/http'

const USER_BASE = '/api/v1/user'

export type CurrentUserInput = {
  access_token: string
}

export function getCurrentUser(input: CurrentUserInput) {
  return apiFetch<CurrentUserResponse>(`${USER_BASE}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${input.access_token}`,
    },
  })
}
